import {
	IMAGE_LIST_APPEND,
	IMAGE_LIST_APPEND_AND_UPDATE_PAGE,
	IMAGE_LIST_FETCHED,
	IMAGE_LIST_FETCHING,
	IMAGE_LIST_FETCH_CANCELLED,
	IMAGE_LIST_LIMIT_REACHED,
	IMAGE_LIST_RESET
} from 'constants/actiontypes';

const INITIAL_STATE = {
	images: [],
	loading: false,
	loaded: false,
	limitReached: false
};


export default (state=INITIAL_STATE, action) => {
	switch(action.type) {
		case IMAGE_LIST_APPEND:
			return Object.assign({}, state, {
				images: state.images.concat(action.images)
			});
		case IMAGE_LIST_APPEND_AND_UPDATE_PAGE:
			return Object.assign({}, state, {
				images: state.images.concat(action.images),
			});
		case IMAGE_LIST_FETCHING:
			return Object.assign({}, state, {loading: true});
		case IMAGE_LIST_FETCHED:
			return Object.assign({}, state, {
				loaded: true,
				loading: false,
				images: action.images,
			});
		case IMAGE_LIST_FETCH_CANCELLED:
			return Object.assign({}, state, {loaded: false, loading: false});
		case IMAGE_LIST_LIMIT_REACHED:
			return Object.assign({}, state, {limitReached: true});
		case IMAGE_LIST_RESET:
			return INITIAL_STATE;
		default:
			return state;
	}
};



/** WEBPACK FOOTER **
 ** ./reducers/imagelist.js
 **/